export default "__VITE_PUBLIC_ASSET__ef81ca3b__"